import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/FeatureBox/FeatureBox';
import {File as FWFile} from 'FW/Models/File';

class FeatureBox extends React.Component {
  render() {
    let section = this.props.section;
    let image = section.prop('image');
    let link = section.prop('link');

    let imageTitle = image.title;
    let imageAlt = image.alt;
    let url = image.src
      ? FWFile.findOrCreate({id: image.src}).helper.thumbnailUrl(this.props.imageWidth)
      : null;
    let imageUrl = url ? url : image.src;

    let linkHref = typeof link.href !== 'undefined' ? link.href : link;

    let title = section.prop('title');
    let content = section.prop('content');
    return (
      <div id="portfolio" className={this.props.getAnimationClass('whole')}>
        <div
          className="portfolio-item"
          style={{marginBottom: '0', textAlign: 'center'}}
        >
          {!FW.inEditor() && linkHref ? (
            <a
              className="portfolio-link"
              href={Helper.fixHref(linkHref)}
              target={section.prop('target') || '_self'}
            >
              <img
                className={
                  'img-responsive' + this.props.getAnimationClass('image')
                }
                style={{
                  paddingLeft: section.prop('image.padding'), paddingRight: section.prop('image.padding'),
                  margin: '0 auto',
                  height: section.prop('image_height') || 'auto'
                }}
                src={imageUrl}
                title={imageTitle}
                alt={imageAlt}
              />
            </a>
          ) : (
            <img
              className={
                'img-responsive' + this.props.getAnimationClass('image')
              }
              style={{
                paddingLeft: section.prop('image.padding'),
                paddingRight: section.prop('image.padding'),
                maxWidth: section.prop('image_maxWidth'),
                margin: '0 auto',
                height: section.prop('image_height') || 'auto',
              }}
              src={imageUrl}
              title={imageTitle}
              alt={imageAlt}
            />
          )}
          <div
            className={
              'portfolio-caption' + this.props.getAnimationClass('text')
            }
          >
            <InlineEditableElement
              fontFamilyChanged={this.props.fontFamilyChanged.bind(this)}
              el="h3"
              html={title}
              {...this.props.inlineEditorProps}
              onChange={this.props.titleChanged.bind(this)}
              inlineEditingEnabled={this.props.inlineEditingEnabled}
            />
            <InlineEditableElement
              fontFamilyChanged={this.props.fontFamilyChanged.bind(this)}
              className="text-muted"
              html={content}
              {...this.props.inlineEditorProps}
              onChange={this.props.contentChanged.bind(this)}
              inlineEditingEnabled={this.props.inlineEditingEnabled}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default hoc(FeatureBox);
